<div>
	@if(isProfessionalPackage){
		@for (item of [].constructor(totalProfessionalPackages > maxShownPackages ? maxShownPackages : totalProfessionalPackages ); track $index) {
			<span [ngClass]="{
				'pending': $index >= getProfessionalPackages().next,
				'closed': $index < getProfessionalPackages().next
			}"></span>
		}
		@if(totalProfessionalPackages > maxShownPackages){
			<span class="centered-text">...</span>
		}
	}@else {
		<!-- Closed packages -->
		@for (closed_package of getOrcadentPackages().closed; track $index) {
			<span class="closed"></span>
		}
		<!-- Active package -->
		@if(getOrcadentPackages().active){
			<span class="active"></span>
		}
		<!-- Pending packages -->
		@for (pending_package of getOrcadentPackages().pending; track $index) {
			<span class="pending"></span>
		}
	}
</div>
